export class FormaDePago {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public  Activo: boolean
    ) { }
}

export class SearchFormaDePagoRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly VerSoloActivos: boolean | null
    ) { }
}

export class SaveFormaDePagoDto {
    constructor(
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Activo: boolean
    ) { }
}

export class SearchFormaDePagoResponse {
    constructor(
      public readonly count: number,
      public readonly result: FormaDePago[]
  ) { }
  }